import { getRandom } from '../../utils/utils';
function draftAutoSettings({
	draftCardDepth,
	draftRandomnessTeam,
	roundBPA,
	roundDepth,
	round,
	playersAll,
	teamDepth,
	tradeValueTeam,
	selectCardDepth,
	roundIndexBool,
	teamUniqPosition,
	roundIndex,
	fanaticChallenge,
	teamPickIndex,
	teamUniqPositionFanaticChallenge,
							   // groupedDuplicates //new 30.06
}) {
	const playerPosition = Array.from({ length: draftCardDepth }, (_, i) => i + 1);
// debugger //me

	console.log(playersAll, "allPlayers")
	const playerRange = playersAll.slice(0, draftCardDepth);
	const tradeValueTeamId = tradeValueTeam.round.index;
	const positionPlayers = [];
	const playerChoose = {};
	console.log(playerRange, "playerRange");
	console.log(playerChoose, "playerChoose")
	// debugger me
	// Round BPA Set
	if (roundBPA?.length && !roundIndexBool) {
		console.log("xmor1")
		const { player, playerChooseIndex } = draftDisableSettings({
			teamUniqPosition,
			playersAll,
			tradeValueTeam,
			roundIndex,
			teamUniqPositionFanaticChallenge,
		});
		playerChoose['player'] = player;
		playerChoose['playerDepth'] = playerChooseIndex;
	}
	// Except  Round 1 Similar Depth
  else if (teamDepth?.length) {
		console.log("xmor2")
		playerChoose['player'] = playerRange[teamDepth[0].playerDepth - 1];
		playerChoose['playerDepth'] = teamDepth[0].playerDepth;
	} 
	else if (roundIndex > roundDepth) {
		playerChoose['player'] = playerRange[0];
		playerChoose['playerDepth'] = 1;
	}
	// Except Top-1 Player Round 1
	else if (draftRandomnessTeam.includes(tradeValueTeamId) && fanaticChallenge?.length === 0) {
		console.log("xmor3")
		let randomFlag = true;
		let randomPosition = null;
		while (randomFlag) {
			randomPosition = getRandom(playerPosition.slice(1, draftCardDepth), 1);

			if (4 >= roundIndex) {
				randomFlag = false;
				break;
			}
			if (!teamUniqPosition[tradeValueTeam.round.name]) {
				randomFlag = false;
			}
			if (
				teamUniqPosition[tradeValueTeam.round.name] &&
				!teamUniqPosition[tradeValueTeam.round.name].includes(playerRange[randomPosition[0] - 1]?.position)
			) {
				randomFlag = false;
			}
		}
		const playerRandomIdExceptTop = playerRange[randomPosition[0] - 1];
		positionPlayers.push(randomPosition[0]);
		playerChoose['player'] = playerRandomIdExceptTop;
		playerChoose['playerDepth'] = randomPosition[0];
	}
	// Round 1
	else {
		console.log("xmor4 here")
		// const [randomPosition] = getRandom(playerPosition.slice(0, draftCardDepth), 1)
		const { player, playerChooseIndex } = draftDisableSettings({
			teamUniqPosition,
			playersAll,
			tradeValueTeam,
			fanaticChallenge,
			roundIndex,
			teamUniqPositionFanaticChallenge,
			// groupedDuplicates //new 30.06
		});
		const randomPosition = playerChooseIndex;
		console.log(randomPosition, "randomPosition")
		const playerRandomId = player;
		positionPlayers.push(randomPosition);
		playerChoose['player'] = playerRandomId;
		playerChoose['playerDepth'] = randomPosition;

		// Pick Card Depth Minimal Last
		if (selectCardDepth?.length > draftCardDepth && !selectCardDepth.includes(draftCardDepth)) {
			playerChoose['player'] = playerRange[draftCardDepth - 1];
			playerChoose['playerDepth'] = draftCardDepth;
		}
	}
	if (playerChoose.player === undefined) {
		const playerAllIndexChoose = playersAll.findIndex(
			player => !teamUniqPosition[tradeValueTeam.round.name].includes(player.position)
		);

		playerChoose['player'] = playersAll[playerAllIndexChoose];
		playerChoose['playerDepth'] = playerAllIndexChoose;
	}

	return playerChoose;
	// // RoundBPA
	// if(roundBPA.includes(round)) {

	// }
}

function draftDisableSettings({
	teamUniqPosition,
	playersAll,
	tradeValueTeam,
	roundIndex,
	fanaticChallenge,
	teamUniqPositionFanaticChallenge,
								  // groupedDuplicates //new30.06
}) {


	const { round_index_number, iteration, round } = tradeValueTeam;
	//console.log(tradeValueTeam, "tradeValueTeam")
	// debugger;





	let playerChoose = null;
	let playerChooseIndex = 0;
	if (fanaticChallenge?.length !== 0 && 4 >= roundIndex) {
		let playerChooseIndex = 0;
		let playerChoose = playersAll[0];
		// let playerChoose = playersAll[1];
		if (tradeValueTeam.pick !== 1) {
			// debugger;
			if ( teamUniqPositionFanaticChallenge[round.name]) {
				// debugger
				// Must match the key setTeamUniqPositionFanaticChallenge writes — `iteration-${n}`, no
				// trailing space. It had one, so the lookup never matched, usedPositions was always
				// empty, and position exclusivity silently never ran in the second round challenge.
				const iterationKey = `iteration-${iteration}`;
				const usedPositions = new Set();

				for (let r = 1; r <= round_index_number; r++) {
					const roundChallenges = teamUniqPositionFanaticChallenge[round.name]?.find(ch => ch.round === r);
					if (roundChallenges && roundChallenges[iterationKey]) {
						roundChallenges[iterationKey].forEach(pos => usedPositions.add(pos));
					}
				}

				playerChooseIndex = playersAll.findIndex(player => !usedPositions.has(player.position));
				playerChoose = playerChooseIndex !== -1 ? playersAll[playerChooseIndex] : playersAll[0];
			}
		}
		return { player: playerChoose, playerChooseIndex: playerChooseIndex + 1 };
	}
	if (4 >= roundIndex) {
		if (teamUniqPosition[tradeValueTeam.round.name]) {
			playerChooseIndex = playersAll.findIndex(
				player => !teamUniqPosition[tradeValueTeam.round.name].includes(player.position)
			);

			playerChoose = playerChooseIndex !== -1 ? playersAll[playerChooseIndex] : playersAll[0];
		} else {
			playerChoose = playersAll[0];
		}
		return { player: playerChoose, playerChooseIndex: playerChooseIndex + 1 };
	} else {
		return { player: playersAll[0], playerChooseIndex: playerChooseIndex + 1 };
	}
}

// The rounds the advanced settings apply to: the first roundDepth rounds that aren't BPA rounds.
// Client: round depth 5 → rounds 1-5; 2-6 with round 1 BPA; 3-7 with rounds 1 and 2 BPA.
function advancedSettingsRounds(roundBPA, roundDepth) {
	const rounds = [];
	for (let r = 1; r <= 7 && rounds.length < roundDepth; r++) {
		if (!roundBPA.includes(r)) rounds.push(r);
	}
	return rounds;
}

// Simulated pick in a plain mock draft, the V2 board (client, 2026-10-04): "The default is every
// team selects the top player on their draft card, the advanced settings override this for 2-16
// teams, for 5 rounds, selecting between the 2nd and 8th player on the draft card (at a position
// the team has not selected in rounds 1-4), the first round BPA is a second override on the
// advanced settings." The top player is draftDisableSettings: rules 2-3 of the plain mock draft,
// position rule rounds 1-4. Challenges and fanatic mode never come here. `random` marks a pick
// made by the settings, for the [PLAIN] log.
function draftPlainSettings({
	draftCardDepth,
	draftRandomnessTeam,
	roundBPA,
	roundDepth,
	playersAll,
	tradeValueTeam,
	teamUniqPosition,
	roundIndex,
}) {
	const topPlayer = () => {
		const { player, playerChooseIndex } = draftDisableSettings({
			teamUniqPosition,
			playersAll,
			tradeValueTeam,
			roundIndex,
			fanaticChallenge: [],
		});
		return { player, playerDepth: playerChooseIndex, random: false };
	};

	if (
		!draftRandomnessTeam.includes(tradeValueTeam.round.index) ||
		!advancedSettingsRounds(roundBPA, roundDepth).includes(roundIndex)
	) {
		return topPlayer();
	}

	const usedPositions = roundIndex <= 4 ? teamUniqPosition[tradeValueTeam.round.name] ?? [] : [];
	const candidates = playersAll
		.slice(1, draftCardDepth)
		.map((player, i) => ({ player, playerDepth: i + 2 }))
		.filter(({ player }) => player && !usedPositions.includes(player.position));
	// Every player in spots 2-8 is at a position the team already has: take its top player instead.
	if (!candidates.length) return topPlayer();

	return { ...candidates[Math.floor(Math.random() * candidates.length)], random: true };
}

export { draftAutoSettings, draftDisableSettings, draftPlainSettings, advancedSettingsRounds };
// function draftDisableSettings({
// 								  teamUniqPosition,
// 								  playersAll,
// 								  tradeValueTeam,
// 								  roundIndex,
// 								  fanaticChallenge,
// 								  teamUniqPositionFanaticChallenge,
// 								  groupedDuplicates
// 							  }) {
// 	const { round_index_number, iteration, round } = tradeValueTeam;
// 	console.log(tradeValueTeam, "tradeValueTeam");
//
// 	let playerChoose = null;
// 	let playerChooseIndex = 0;
//
// 	if (fanaticChallenge?.length !== 0 && roundIndex <= 4) {
// 		playerChooseIndex = 0;
// 		playerChoose = playersAll[0];
//
// 		if (tradeValueTeam.pick !== 1) {
// 			if (teamUniqPositionFanaticChallenge[round.name]) {
// 				const iterationKey = `iteration-${iteration} `;
// 				const usedPositions = new Set();
//
// 				// 1️⃣ Collect positions from teamUniqPositionFanaticChallenge
// 				for (let r = 1; r <= round_index_number; r++) {
// 					const roundChallenges = teamUniqPositionFanaticChallenge[round.name]?.find(ch => ch.round === r);
// 					if (roundChallenges && roundChallenges[iterationKey]) {
// 						roundChallenges[iterationKey].forEach(pos => usedPositions.add(pos));
// 					}
// 				}
//
// 				// 2️⃣ Add positions from groupedDuplicates that match round/index/iteration
// 				for (const group of groupedDuplicates) {
// 					for (const item of group) {
// 						if (
// 							item.round_index_number === round_index_number &&
// 							item.iteration === iteration &&
// 							item.round === round &&
// 							item.player?.position
// 						) {
// 							usedPositions.add(item.player.position);
// 						}
// 					}
// 				}
//
// 				// 3️⃣ Find first available player not in usedPositions
// 				playerChooseIndex = playersAll.findIndex(player => !usedPositions.has(player.position));
// 				playerChoose = playerChooseIndex !== -1 ? playersAll[playerChooseIndex] : playersAll[0];
// 			}
// 		}
//
// 		return { player: playerChoose, playerChooseIndex: playerChooseIndex + 1 };
// 	}
//
// 	if (roundIndex <= 4) {
// 		if (teamUniqPosition[tradeValueTeam.round.name]) {
// 			playerChooseIndex = playersAll.findIndex(
// 				player => !teamUniqPosition[tradeValueTeam.round.name].includes(player.position)
// 			);
// 			playerChoose = playerChooseIndex !== -1 ? playersAll[playerChooseIndex] : playersAll[0];
// 		} else {
// 			playerChoose = playersAll[0];
// 		}
// 		return { player: playerChoose, playerChooseIndex: playerChooseIndex + 1 };
// 	} else {
// 		return { player: playersAll[0], playerChooseIndex: playerChooseIndex + 1 };
// 	}
// }
//
// export { draftAutoSettings, draftDisableSettings };